module.exports = "/_next/static/images/uv-fingerPrint-8c86736ec1baa0c74c99a9522ccaea64.png";